import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ObjectComboMappingAction} from "./ObjectComboMappingActionMenu";
import {useObjectComboMappingMutation} from "../../../hooks/useObjectComboMappingMutation";
import {ObjectComboMapping} from "@ots-frontend/ots-data";

export type UseObjectComboMappingActionProps = {}

export type UseObjectComboMappingActionResult = {
  onObjectComboMappingActionClick: (permission: ObjectComboMapping, action: ObjectComboMappingAction) => void;
}

export const useObjectComboMappingAction = (props: UseObjectComboMappingActionProps = {}): UseObjectComboMappingActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteObjectComboMapping,
  } = useObjectComboMappingMutation()

  const _onObjectComboMappingActionClick = useCallback((role: ObjectComboMapping, action: ObjectComboMappingAction) => {
    if (action === "EDIT") {
      navigate(`/object-combo-mappings/form`, {state: {id: role.id}})
    } else if (action === "DELETE") {
      deleteObjectComboMapping(role.id, undefined)
    }
  }, [navigate, deleteObjectComboMapping])

  return {
    onObjectComboMappingActionClick: _onObjectComboMappingActionClick
  }
}
